import { useState } from "react";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "How soon can you start a new project?",
      answer: "Project timelines depend on site readiness and approvals, but we typically start within one to two weeks.",
    },
    {
      question: "Do you handle both residential and commercial work?",
      answer: "Yes, we execute residential, commercial, and selected industrial construction with the same quality process.",
    },
    {
      question: "Do you provide cost estimates before starting?",
      answer: "Yes, we provide transparent estimates after reviewing scope, materials, and project requirements.",
    },
    {
      question: "Can I schedule a site consultation?",
      answer: "Yes, use the contact form or call us directly to book a consultation with our project team.",
    },
  ];

  return (
    <section id='faq' className='faq-section py-2'>
      <div className='container'>
        <h2 className='text-center website-section-title mb-4'>Frequently Asked Questions</h2>
        <div className='accordion faq-accordion' id='faqAccordion'>
          {faqs.map((faq, index) => (
            <div className='accordion-item' key={index}>
              <h2 className='accordion-header' id={`heading${index}`}>
                <button
                  className={`accordion-button ${activeIndex === index ? "" : "collapsed"}`}
                  type='button'
                  onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent='#faqAccordion'
              >
                <div className='accordion-body'>{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
